import { transition as d } from '../components/transitions/utils/transition.js';
import { disposables as l } from '../utils/disposables.js';
import { useDisposables as f } from './use-disposables.js';
import { useIsMounted as m } from './use-is-mounted.js';
import { useIsoMorphicEffect as p } from './use-iso-morphic-effect.js';
import { useLatestValue as b } from './use-latest-value.js';
function D(_ref) {
  var i = _ref.container,
    t = _ref.direction,
    o = _ref.classes,
    s = _ref.onStart,
    u = _ref.onStop;
  var a = m(),
    c = f(),
    r = b(t);
  p(function () {
    var e = l();
    c.add(e.dispose);
    var n = i.current;
    if (n && r.current !== "idle" && a.current) return e.dispose(), s.current(r.current), e.add(d(n, o.current, r.current === "enter", function () {
      e.dispose(), u.current(r.current);
    })), e.dispose;
  }, [t]);
}
export { D as useTransition };